/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SetCustomEmailSettingsRequestSettings } from './SetCustomEmailSettingsRequestSettings';
import {
    SetCustomEmailSettingsRequestSettingsFromJSON,
    SetCustomEmailSettingsRequestSettingsFromJSONTyped,
    SetCustomEmailSettingsRequestSettingsToJSON,
    SetCustomEmailSettingsRequestSettingsToJSONTyped,
} from './SetCustomEmailSettingsRequestSettings';

/**
 * 
 * @export
 * @interface SetCustomEmailSettingsRequest
 */
export interface SetCustomEmailSettingsRequest {
    /**
     * Whether to use custom email delivery for this serviceprovider.
     */
    enabled: boolean;
    /**
     * 
     */
    settings?: SetCustomEmailSettingsRequestSettings;
}

/**
 * Check if a given object implements the SetCustomEmailSettingsRequest interface.
 */
export function instanceOfSetCustomEmailSettingsRequest(value: object): value is SetCustomEmailSettingsRequest {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function SetCustomEmailSettingsRequestFromJSON(json: any): SetCustomEmailSettingsRequest {
    return SetCustomEmailSettingsRequestFromJSONTyped(json, false);
}

export function SetCustomEmailSettingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetCustomEmailSettingsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'settings': json['settings'] == null ? undefined : SetCustomEmailSettingsRequestSettingsFromJSON(json['settings']),
    };
}

export function SetCustomEmailSettingsRequestToJSON(json: any): SetCustomEmailSettingsRequest {
    return SetCustomEmailSettingsRequestToJSONTyped(json, false);
}

export function SetCustomEmailSettingsRequestToJSONTyped(value?: SetCustomEmailSettingsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'settings': SetCustomEmailSettingsRequestSettingsToJSON(value['settings']),
    };
}

